import React, { createContext, useContext } from 'react';
import UserMenu from './UserMenu';
import SidebarNavigation from './SidebarNavigation';
import UpgradeCard from './UpgradeCard';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { ChevronsLeft, ChevronsRight, Menu } from 'lucide-react';


type SidebarContextType = {
    showSidebar: boolean;
    isCompact: boolean;
    setShowSidebar: (showSidebar: boolean) => void;
}

const SidebarContext = createContext<SidebarContextType>({
    showSidebar: false,
    isCompact: false,
    setShowSidebar: () => { },
});

export const useSidebarContext = () => {
    return useContext(SidebarContext);
}

interface SidebarProps {
    showSidebar: boolean;
    isCompact: boolean;
    setShowSidebar: (showSidebar: boolean) => void;
    isSidebarHovered: boolean;
    setIsSidebarHovered: (hovered: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ 
    showSidebar, 
    isCompact, 
    setShowSidebar, 
    isSidebarHovered, 
    setIsSidebarHovered 
}) => {
    // Sidebar is expanded if either showSidebar is true OR if collapsed but being hovered
    const isExpanded = showSidebar || isSidebarHovered;

    return (
        <SidebarContext.Provider value={{ showSidebar: isExpanded, isCompact, setShowSidebar }}>
            <div className="hidden border-none sm:block overflow-hidden">
                <div 
                    className={cn(
                        "hidden sm:flex h-screen flex-col gap-2 sticky top-0 transition-all duration-200 ease-in-out",
                        isExpanded ? "w-[220px] lg:w-[220px]" : "w-[72px]"
                    )}
                    onMouseEnter={() => !showSidebar && setIsSidebarHovered(true)}
                    onMouseLeave={() => setIsSidebarHovered(false)}
                >
                    <div className={cn( "flex flex-row h-14 items-center border-none pl-2 pr-4 lg:h-[60px] lg:pr-6 gap-2 transition-all duration-200 ease-in-out",
                         {
                            "lg:px-4 px-2": !isExpanded
                         })}>
                        <UserMenu />
                        <Button variant="ghost" size="icon" className="" onClick={() => setShowSidebar(!showSidebar)}>
                            {showSidebar ? <ChevronsLeft className="h-4 w-4 text-foreground-muted" /> : <ChevronsRight className="h-4 w-4 text-foreground-muted" />}
                            
                        </Button>

                    </div>

                    <div className="flex-1">
                        <SidebarNavigation showSidebar={isExpanded} />
                    </div>

                    {/* <div className="mt-auto p-4 overflow-hidden">
                        <UpgradeCard />
                    </div> */}
                </div>
            </div>
        </SidebarContext.Provider>
    );
};

export default Sidebar;
